import CancelableAxiosInstance from "../api/CancelableAxiosInstance";
import { Buffer } from "buffer";

export default class ImageUtils {
  public static pathToImageElement(client: CancelableAxiosInstance, path: string): Promise<HTMLImageElement> {
    return this.downloadImageContent(client, path).then((data) => {
      const image = new Image();
      image.src = data;
      return image;
    });
  }

  public static downloadImageContent(client: CancelableAxiosInstance, path: string) {
    return client.get(`/images/${path}`, { responseType: "arraybuffer" }).then((response) => {
      return `data:${response.headers["content-type"]};base64,${Buffer.from(response.data).toString("base64")}`;
    });
  }
}

export const isLabelableImage = (labelableTags: string[], imageTags: Array<string>): boolean => {
  if (labelableTags.length > 0) {
    return imageTags.some((iTags) => labelableTags.includes(iTags));
  }
  return true;
};
